import { render, staticRenderFns } from "./store-contest-record.vue?vue&type=template&id=5e65905d&scoped=true&"
import script from "./store-contest-record.vue?vue&type=script&lang=js&"
export * from "./store-contest-record.vue?vue&type=script&lang=js&"
import style0 from "./store-contest-record.vue?vue&type=style&index=0&id=5e65905d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e65905d",
  null
  
)

export default component.exports